import { render, staticRenderFns } from "./LogoPicker.vue?vue&type=template&id=55a15294&"
import script from "./LogoPicker.vue?vue&type=script&lang=js&"
export * from "./LogoPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports